import { CircularProgress } from '@mui/material'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { redirectUrl } from '@1eg/lib-core-web-components-js'
import { useIamManagerAuthorization } from 'services/api/iam/manager/useIamManagerAuthorization'
import decode from 'jwt-decode'
import { Token } from 'interfaces/Token'

export default function Gateway() {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  const { loginWithSelectedAccount } = useIamManagerAuthorization()

  useEffect(() => {
    function handleGatewayError() {
      navigate('/')
    }

    async function handleGateway() {
      const token = String(searchParams.get('current_token'))
      const accountId = searchParams.get('account_id')
      const productId = searchParams.get('product_id')

      const moovinProducts: Record<string, string> = {
        account: 'account',
        store: 'store',
        oms: 'oms',
        crm: 'crm',
        hub: 'hub',
        desk: 'desk'
      }

      if (!productId || !moovinProducts[productId]) return handleGatewayError()

      try {
        const decodedToken = decode<Token>(token)

        const {
          data: { token: newToken }
        } = await loginWithSelectedAccount({
          token,
          accountId: accountId || decodedToken.account.id
        })

        const {
          account: { products }
        } = decode<Token>(newToken)

        if (productId !== 'account' && products[productId]?.status !== 'Available')
          window.location.href = redirectUrl('account', {
            routeParams: ['subscriptions', 'plans', productId],
            queryParams: { token: newToken }
          })
        else window.location.href = redirectUrl(moovinProducts[productId], { queryParams: { token: newToken } })
      } catch {
        handleGatewayError()
      }
    }
    handleGateway()
  }, [searchParams])

  return (
    <CircularProgress
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    />
  )
}
